import type { SystemName } from '@mynt/backoffice-api-spec/ledger-platform'
import { prettifyEnumLabel } from 'helpers/CreditOnCardHelpers'

export type { SystemName }

export interface LedgerConnection {
  systemName: SystemName | undefined
}

const systemNameLabels: Record<SystemName, string> = {
  FORTNOX: 'Fortnox',
  BJORN_LUNDEN: 'Björn Lundén',
  BUSINESS_CENTRAL: 'Business Central',
  CSV_DOWNLOAD: 'CSV download',
  SIE_DOWNLOAD: 'SIE download',
  POWER_OFFICE: 'PowerOffice',
  VISMA_NET: 'Visma.net',
  TRIPLETEX: 'Tripletex',
  NETVISOR: 'Netvisor',
  PROCOUNTOR: 'Procountor',
  EXACT_ONLINE: 'Exact Online',
  FINAGO_TFSO: 'Finago (24SevenOffice)',
  BOKIO: 'Bokio',
  DEMO: 'Demo',
  OQTO: 'Oqto',
  SPIRIS: 'Spiris',
  ECONOMIC: 'e-conomic',
}

export const getSystemNameLabel = (systemName: SystemName): string => systemNameLabels[systemName] ?? prettifyEnumLabel(systemName)
